<template>
  <main class="dashboard reviews">
    <ReviewHead></ReviewHead>

    <div class="table-flex-responsive">
 <a v-if="settings?.report_full_report" style="width: 150px" class="btn btn-dark btn-sm full-report" :href="settings.report_full_report+'?ver='+Math.random()">
   Полный отчёт <i class="bi bi-download"></i></a>
      <div class="row header sticky">
        <div class="col-1"> №</div>
        <div class="col-5">Период</div>
        <div class="col">Дата создания</div>
        <div class="col-3">Ссылка</div>

      </div>
      <template v-for="(object, index) in objects">
        <div class="row line">

          <div class="col-1 number">
            <div class="sub-head">№</div>

            {{ (index + 1) + ((page - 1) * size) }}
          </div>
          <div class="col sub-head">Период</div>
          <div class="col-lg-5">
            {{ $moment(object.date_from).format("DD.MM.YY") }} - {{ $moment(object.date_to).format("DD.MM.YY") }}
          </div>
          <div class="col sub-head">Дата создания</div>
          <div class="col">
            {{ $moment(object.date_create).format("DD.MM.YY HH:mm") }}
          </div>
          <div class="col sub-head"></div>
          <div class="col-3">
            <a :href="object.report_file" class="btn btn-sm btn-dark">Скачать</a>

          </div>

        </div>
      </template>
      <div v-if="!objects.length" class="row">
        <div class="col-12 text-center">
          Нет запрошенных отчётов
        </div>
      </div>

    </div>


    <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>


  </main>
</template>

<script>
import dataMixin from '../mixins.js';
import {DictionaryApi} from '@/api/dictionary'
import ReviewHead from "@/views/dictionary/review/ReviewHead.vue";

export default {
  name: 'ReviewReports',
  components: {ReviewHead},
  mixins: [dataMixin],
  data() {
    return {
      name: 'reviews_monitor_report',
      settings: null,
    }
  },
  mounted() {
    DictionaryApi.get_review_settings('reviews_monitor').then(response => this.settings = response)

  },
  methods: {}
}
</script>
<style>

.full-report {
  display: flex;
  align-items: center;
}
</style>


